import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid-pro';

type GridStore = {
  paginationModel: {
    page: number;
    pageSize: number;
  };
  gridSortModel: GridSortModel;
  columnVisibilityModel: GridColumnVisibilityModel;
  columnOrder: string[];
  manualColumnView: boolean;
  setManualColumnView: (manual: boolean) => void;
  setColumnVisibilityModel: (model: GridColumnVisibilityModel) => void;
  setColumnOrder: (order: string[]) => void;
  setGridSortModel: (model: GridSortModel) => void;
  setPaginationModel: (model: { page: number; pageSize: number }) => void;
  resetPagination: () => void;
  resetColumnOrder: () => void;
};

const useGridStore = create<GridStore>()(
  persist(
    devtools(
      immer((set) => ({
        paginationModel: {
          page: 0,
          pageSize: 10,
        },
        // TODO: change for i6
        // @ts-ignore: entity detail name across all orgs and envs for pre i6
        gridSortModel: [{ field: '10006', sort: 'asc' }],
        columnVisibilityModel: {},
        columnOrder: [],
        manualColumnView: false,
        setManualColumnView: (manual) =>
          set((state) => ({
            manualColumnView: manual,
          })),
        setColumnVisibilityModel: (model) =>
          set((state) => ({
            columnVisibilityModel: model,
          })),
        setColumnOrder: (order) =>
          set((state) => ({
            columnOrder: order,
          })),
        setGridSortModel: (model) =>
          set((state) => ({
            gridSortModel: model,
          })),
        setPaginationModel: (model) =>
          set((state) => ({
            paginationModel: model,
          })),
        resetPagination: () =>
          set((state) => ({
            paginationModel: {
              page: 0,
              pageSize: 10,
            },
          })),
        resetColumnOrder: () =>
          set((state) => ({
            columnOrder: [],
          })),
      })),
      { name: 'GridStore' },
    ),
    {
      name: 'GridStore',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useGridStore;
